export class ResponseError extends Error {
    constructor(messages) {
        super();
        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ResponseError);
        }

        this.name = 'ResponseError';
        this.message = 'Response error from server';
        this.messages = messages;
        this.toString = () => {
            return messages.map((x)=>{return x.text;}).join(',');
        };
    }
}